"use client";

import DecklistsTable from "@/components/Decklists/DecklistsTable";
import { IDecklistV2 } from "@/models/decklist";
import { SupportedGames } from "@/types/game";

interface EventDecklistsProps {
  decklists: IDecklistV2[];
  game: SupportedGames;
}

export default function EventDecklists({
  decklists,
  game,
}: EventDecklistsProps) {
  return (
    <DecklistsTable
      game={game}
      decklists={decklists}
      isLoading={false}
      showPagination={false}
    />
  );
}
